import { useState, useEffect } from 'react'
import { useProject } from '../stores/ProjectContext'
import { useI18n } from '../stores/I18nContext'
import './AxisModal.css'

export default function XAxisModal({ isOpen, onClose }) {
  const { project, updateProject } = useProject()
  const { language } = useI18n()
  const isNorwegian = language === 'nb'

  const [mode, setMode] = useState('weeks')
  const [rangeStart, setRangeStart] = useState(0)
  const [rangeEnd, setRangeEnd] = useState(12)

  useEffect(() => {
    if (project) {
      setMode(project.timeUnit || 'weeks')
      setRangeStart(project.xAxisStart || 0)
      setRangeEnd(project.xAxisEnd || 12)
    }
  }, [project, isOpen])

  if (!isOpen) return null

  const modeOptions = [
    { value: 'weeks', label: isNorwegian ? 'Uker' : 'Weeks' },
    { value: 'days', label: isNorwegian ? 'Dager' : 'Days' },
    { value: 'phases', label: isNorwegian ? 'Faser' : 'Phases' },
    { value: 'sprints', label: isNorwegian ? 'Sprints' : 'Sprints' },
    { value: 'steps', label: isNorwegian ? 'Steg' : 'Steps' }
  ]

  const handleSave = () => {
    updateProject({
      timeUnit: mode,
      xAxisStart: rangeStart,
      xAxisEnd: rangeEnd
    })
    onClose()
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="axis-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{isNorwegian ? 'X-akse konfigurasjon' : 'X-axis Configuration'}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label>{isNorwegian ? 'Modus' : 'Mode'}</label>
            <select value={mode} onChange={(e) => setMode(e.target.value)}>
              {modeOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>{isNorwegian ? 'Start' : 'Start'}</label>
              <input
                type="number"
                value={rangeStart}
                onChange={(e) => setRangeStart(parseInt(e.target.value) || 0)}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>{isNorwegian ? 'Slutt' : 'End'}</label>
              <input
                type="number"
                value={rangeEnd}
                onChange={(e) => setRangeEnd(parseInt(e.target.value) || 12)}
                min="1"
              />
            </div>
          </div>

          <div className="form-hint">
            {isNorwegian
              ? `Viser ${rangeEnd - rangeStart} ${modeOptions.find(o => o.value === mode)?.label.toLowerCase()}`
              : `Showing ${rangeEnd - rangeStart} ${modeOptions.find(o => o.value === mode)?.label.toLowerCase()}`
            }
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            {isNorwegian ? 'Avbryt' : 'Cancel'}
          </button>
          <button className="btn btn-primary" onClick={handleSave}>
            {isNorwegian ? 'Lagre' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  )
}
